// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__242po","dragIcon":"SortableItem_dragIcon__1RPFy","disabled":"SortableItem_disabled__39qZt"};